const bracketMapPrice = new Map([
    ["mb1-bracket", "$7.60 USD"],
    ["mb6", "$9.75 USD"],
    ["mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators", "$17.85 USD"],
    ["mb1-p", "$8.80 USD"],
    ["mb3u", "$10.30 USD"],
    ["mb3", "$8.00 USD"],
    ["mb5",  "$18.15 USD"],
    ["mb2", "$6.90 USD"],
    ["mb-pb-premium-base-mounting-bracket", "$8.65 USD"],
    ["mb8-bracket", "$13.80 USD"],
    ["mb14-bracket", "$6.25 USD"],
    ["mb9-bracket", "$6.80 USD"],
    ["mb6-p-bracket", "$9.75 USD"],
    ["mb50-mounting-bracket", "$16.10 USD"],
    ["mb36sm", "$9.25 USD"],
    ["mb50", "$21.25 USD"],
    ["pulley-lifting-cables-for-linear-actuators", "$18.00 USD"],
    ["mb36", "$16.25 USD"],
    ["mb36c", "$11.25 USD"],
    ["mb50c", "$8.75 USD"],
    ["mb35-mounting-bracket", "$11.25 USD"],
    ["mb7", "$3.00 USD"],
    ["mb-17-mounting-bracket-for-super-duty-actuators", "$8.80 USD"]
]);